export const CASHBACK_PERCENTAGE_VALUE = 0.05;
export const CASHBACK_MAX_VALUE = 60.0;
export const CASHBACK_MAX_SPEND_VALUE = 1200.0;
export const LOCALSTORAGE_KEY = 'velobankCashbackCalculatorData';
